export const INTERMEDIARY_ERRORS = Object.freeze({
    nameRequired: "Missing required field: List Name",
    nameMaxLengthExceeded: "Character length must not exceed 50",
    nameExist: "List Name already exists",
    accountNo:
        "Missing required field: Account No(must be of format XXXXXX-XXXX)",
    accountNoInvalid:
        "Invalid field: Account No(must be of format XXXXXX-XXXX)",
    slbAccountNo: "Missing required field: SLB Number (must be of format XX)",
    slbAccountNoInvalid: "Invalid field: SLB Number (must be of format XX)",
    ksdFundCode: "Missing required field: KSD Fund Code",
    slbNumberInvalid: "Invalid field: SLB Number (must be of format XX)",
    ksdFundCodeInvalid: "Invalid field: KSD Fund Code",
    ksfcFundCodeInvalid: "Invalid field: KSFC Fund Code",
    internalFundCodeInvalid: "Invalid field: Internal Fund Code",
    custodyAssetType:
        "Invalid field: Custody Asset Type (must be of format XX)",
    dividend: "Invalid field: Dividend (Must be 0 ≤ Div ≤ 100)",
    noCodeExists: "You must enter at least one KSD fund code or SLB number",
    internalFundCodeCharacterLengthExceeded:
        "Character length must not exceed 12",
    ksfcFundCodeCharacterLengthExceeded: "Character length must not exceed 12",
    ksdFundCodeCharacterLengthExceeded: "Character length must not exceed 12",
    collCcyRequired: "Missing required field: Collateral Currency",
});

export const FUND_SETTING_ERRORS = Object.freeze({
    fundNameRequired: "Missing required field: Fund Name",
    fundNameExist: "Fund Name already exists",
    noCodeExists: "You must enter at least one KSD fund code or SLB number",
    slbNumberInvalid: "Invalid field: SLB Number (must be of format XX)",
    fundNameMaxLengthExceeded: "Character length must not exceed 50",
    ksdFundCodeInvalid: "KSDFund code character length must not exceed 12",
    ksfcFundCodeInvalid: "Invalid field: KSFC Fund Code",
    internalFundCodeInvalid: "Invalid field: Internal Fund Code",
    internalFundCodeCharacterLengthExceeded:
        "Character length must not exceed 12",
    ksfcFundCodeCharacterLengthExceeded: "Character length must not exceed 12",
    ksdFundCodeCharacterLengthExceeded: "Character length must not exceed 12",
});

export const PREFERRED_CRITERION = Object.freeze({
    LIST_ORDER: "LIST_ORDER",
    EQUAL: "EQUAL",
});
